<template>
    <div class="background-supplement-no-title-layout">
        <div class="layout-content user-content form">
            <form class="user-password">
                <div class="form-list password-validate">
                    <label>原密码:</label>
                    <el-input type="password" v-model="originalPassword" placeholder="请输入原密码" @blur="blurPassword('originalPassword','originalVerify')" @focus="focusInput('originalVerify')" :maxlength="20"></el-input>
                    <div class="validate" :class="originalVerify"><i></i></div>
                </div>
                <div class="form-list password-validate">
                    <label>新密码:</label>
                    <el-input type="password" v-model="newPassword" placeholder="请设置6位以上密码，支持英文、数字、符号" @blur="blurPassword('newPassword','newVerify')" @focus="focusInput('newVerify')" :maxlength="20"></el-input>
                    <div class="validate" :class="newVerify"><i></i></div>
                </div>
                <div class="form-list password-validate">
                    <label>确认新密码:</label>
                    <input type="password" style="display: none">
                    <el-input type="password" v-model="confirmPassword" placeholder="请重复输入新密码" @blur="blurPassword('confirmPassword','confirmVerify')" @focus="focusInput('confirmVerify')" :maxlength="20"></el-input>
                    <div class="validate" :class="confirmVerify"><i></i></div>
                </div>
                <div class="form-list" style="margin-top: 10px;height: 20px;line-height: 20px;">
                    <div class="warning-content" :class="warnVerify"><i></i>{{ warnMsg ? warnMsg : '' }}</div>
                </div>
                <div class="form-list" style="margin-top: 0">
                    <el-button v-loading="loading" class="form-btn" @click="handleModifyPwd">修改密码</el-button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            flag: true, // 防止异步请求重复发送
            loading: false,
            originalPassword: '',
            originalVerify: '',
            newPassword: '',
            newVerify: '',
            confirmPassword: '',
            confirmVerify: '',
            warnVerify: null,
            warnMsg: ''
        };
    },
    methods: {
        blurPassword(pwd, verify) {
            let password = this[pwd];
            if (password) {
                this.checkPassword(password, verify);
            }
        },
        focusInput(verify) {
            this[verify] = '';
            this.warnVerify = '';
            this.warnMsg = '';
        },
        checkPassword(password, verify) {
            if (verify === 'originalVerify') {
                if (!password) {
                    this.originalVerify = 'empty';
                    return false;
                }
                return true;
            }
            let passReg = /^[a-zA-Z\d!#$%^&*_]{6,20}$/;
            if (!password) {
                this[verify] = 'empty';
                return false;
            } else if (passReg.test(password)) {
                if (verify === 'confirmVerify' && password !== this.newPassword) {
                    this[verify] = 'difference';
                    return false;
                }
                this[verify] = 'right';
                return true;
            }
            this[verify] = 'error';
            return false;
        },
        handleModifyPwd() {
            if (this.flag) {
                let that = this;
                that.flag = false;
                let originalPassword = this.originalPassword;
                let newPassword = this.newPassword;
                let confirmPassword = this.confirmPassword;
                let checkOriginal = this.checkPassword(originalPassword, 'originalVerify');
                let checkNew = this.checkPassword(newPassword, 'newVerify');
                let checkConfirm = this.checkPassword(confirmPassword, 'confirmVerify');
                if (checkOriginal && checkNew && checkConfirm) {
                    this.loading = true;
                    that.$http
                        .put('/v1/user-center/password', {
                            oldPassword: originalPassword,
                            newPassword
                        })
                        .then(resp => that.$checkResp(resp))
                        .then(() => {
                            that.$message.info('密码修改成功');
                            that.$router.push({ name: 'basic@user' });
                        })
                        .catch(err => {
                            that.warnVerify = 'error';
                            that.warnMsg = err.msg;
                        }).finally(() => {
                            that.flag = true;
                            that.loading = false;
                        });
                } else {
                    that.flag = true;
                }
            }
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .user-password {
        padding: 70px 55px;

        .form-list {
            label {
                text-align: right;
            }

            .difference {
                color: #ef6752;

                i {
                    width: 10px;
                    height: 10px;
                    background: url(../../../assets/images/common/wrong-icon.png) no-repeat;
                    background-size: contain;
                }
            }

            .difference::after {
                content: '两次密码输入不一致';
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/index/components/UserPassword.vue